import { useEffect } from 'react';
import Quiz from '../../components/Quiz';
import PageHeader from '../../components/PageHeader';

function QuizPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "The Quiz - Austrian Process";
  }, []);

  return (
    <div className="page-container">
      <PageHeader
        title="The Austrian Economics Quiz"
        description="Ten questions, drawn at random from fifty. Austrian Economics, tested."
      />
      <Quiz />
    </div>
  );
}

export default QuizPage;
